import { Box } from '@mui/material'
import { EmtSeparator, EmtTypography } from 'emt-components-v2'
import { useTranslation } from 'react-i18next'
import 'react-phone-number-input/style.css'
import NextMuiLink from './NextMuiLink'
import { appendParamsIfNeeded } from '@/utils'
import { Routes } from '@/assets/configs'

const ConnectionLink: React.FC = () => {
  const { t } = useTranslation('connection')

  return (
    <>
      <Box sx={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
        <Box sx={{ flex: '2 1 auto' }}>
          <EmtSeparator />
        </Box>

        <Box>
          <EmtTypography variant="body1" color="greyGradient.300" fontWeight={700}>
            {t('sign-in.or')}
          </EmtTypography>
        </Box>

        <Box sx={{ flex: '2 1 auto' }}>
          <EmtSeparator />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
        <EmtTypography variant="body2" fontWeight={700}>
          {t('sign-in.hardPassword')}
        </EmtTypography>

        <EmtTypography color="greyGradient.light" variant="caption" fontWeight={600}>
          {t('sign-in.hardPasswordText')}
        </EmtTypography>
      </Box>

      <EmtTypography variant="body1" sx={{ textAlign: 'center' }} fontWeight={700}>
        <NextMuiLink
          href={appendParamsIfNeeded(Routes.Connection.ConnectionLink)}
          title={t('sign-in.receiveLink') as string}
        >
          {t('sign-in.receiveLink')}
        </NextMuiLink>
      </EmtTypography>
    </>
  )
}

export default ConnectionLink
